import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CreditCard, Merchant, PaymentType } from './merchant-details.model';
import { MerchantDetailsState } from './merchant-details.state';

/**
 * Selects the entire merchant state
 * @param state The app state
 * @returns The merchant state
 */
export const selectMerchant = createFeatureSelector<MerchantDetailsState>('merchant');

/**
 * Selects merchant details state
 * @returns The merchant details state
 */
export const selectMerchantDetails = createSelector(selectMerchant, (merchant) => merchant.merchant);

export const selectIsTradesMerchant = createSelector(
	selectMerchantDetails,
	(state: Merchant): boolean => state?.isTradeMerchant
);
/**
 * Selects the merchant's default language
 */
export const selectMerchantDefaultLanguage = createSelector(selectMerchant, (state): string => state.defaultLanguage);

/**
 * Selects the merchant payment types
 */
export const selectMerchantPaymentTypes = createSelector(
	selectMerchantDetails,
	(state: Merchant): PaymentType[] => state.paymentTypes
);

/**
 * Returns credit cards for the merchant
 */
export const selectCreditCards = createSelector(selectMerchantDetails, (state: Merchant): CreditCard[] => {
	return state.creditCards;
});

/**
 * Find out if we have apple pay configured
 */
export const selectApplePayCards = createSelector(selectMerchantDetails, (state: Merchant): CreditCard[] => {
	return state.applePayCards;
});

/**
 * Find out if we have google pay configured
 */
export const selectGooglePayCards = createSelector(selectMerchantDetails, (state: Merchant): CreditCard[] => {
	return state.googlePayCards;
});
